import type { ContactSummary } from '../../types/contact'
import { useContactStore } from '../../store/contactStore'
import { SPECIES_LABELS, STATUS_LABELS } from '../../constants/taxonomy'
import { STATUS_COLORS } from '../map/confidenceStyle'

function formatRelativeTime(isoString: string): string {
  const diff = Date.now() - new Date(isoString).getTime()
  const mins = Math.floor(diff / 60_000)
  if (mins < 1) return 'just now'
  if (mins < 60) return `${mins}m ago`
  const hrs = Math.floor(mins / 60)
  if (hrs < 24) return `${hrs}h ago`
  return `${Math.floor(hrs / 24)}d ago`
}

export default function ContactCard({ contact }: { contact: ContactSummary }) {
  const { selectedContactId, selectContact } = useContactStore()
  const isSelected = selectedContactId === contact.id
  const color = STATUS_COLORS[contact.status]

  return (
    <button
      type="button"
      onClick={() => selectContact(contact.id)}
      className={`w-full text-left p-3 rounded-lg border transition-colors ${
        isSelected ? 'bg-gray-200 border-gray-400' : 'bg-white border-gray-200 hover:bg-gray-100 hover:border-gray-300'
      }`}
    >
      <div className="flex items-center gap-2 flex-wrap mb-1">
        <span
          className="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium"
          style={{ color, backgroundColor: color + '1a' }}
        >
          {STATUS_LABELS[contact.status]}
        </span>
        <span className="text-xs text-gray-500">{SPECIES_LABELS[contact.species_bucket]}</span>
      </div>
      <p className="text-sm text-gray-900">
        {contact.report_count} report{contact.report_count === 1 ? '' : 's'}
        {contact.is_declared && ' · officially linked'}
      </p>
      <p className="text-xs text-gray-500 mt-1">{formatRelativeTime(contact.last_updated_at)}</p>
    </button>
  )
}
